import { amILoggedIn } from '@/js/app/support/utils';
import axios from "axios";
import { NotificationAlert } from "@/js/interfaces/Components/alpinejs/NotificationAlert";
import { Store } from '../app/services/Store';
import { notifyAlert, notifyBanner } from '../app/support/alert-and-banner';

if (amILoggedIn()) {
    axios.get('/api/will-maintenance-happens')
        .then(response => {
            const data = response.data as ({
                items: Array<({ id: number } & NotificationAlert)>
            });

            if (data.items.length > 0) {
                const alert = data.items[0];

                if (alert && !Store.idMaintenanceIdStored(alert.id)) {
                    // Display alerts if passed from the server
                    notifyAlert(
                        alert.title,
                        alert.message,
                        alert.type,
                        alert.duration,
                        () => Store.storeMaintenanceId(alert.id),
                    );

                    notifyBanner(
                        alert.message,
                        alert.type,
                        () => Store.storeMaintenanceId(alert.id),
                    );
                }
            }
        });
}
